import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatName',
    standalone: false
})

export class FormatNamePipe implements PipeTransform {
    transform(value:string): string {
        if (!value) return value;
        var s3 =   `${value.toUpperCase()} \n`;
        return s3;
    }
}

  
